import { Component, Inject, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CoreConfigService } from '@core/services/config.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CalibrationService } from 'app/services/models/calibration.service';
import { CertificateReservationService } from 'app/services/models/certificate-reservation.service';
import { CertificateService } from 'app/services/models/certificate.service';
import { Turkish } from 'flatpickr/dist/l10n/tr';
import moment from 'moment';
import { FlatpickrOptions } from 'ng2-flatpickr';
import { ToastrService } from 'ngx-toastr';
import { Subject, takeUntil } from 'rxjs';
import * as pdfjsLib from 'pdfjs-dist';
import htmlToPdfmake from 'html-to-pdfmake';
import { CalibrationData, CalibrationPage2, headerBilgileri, Reference } from '../create-certificate-dialog/create-certificate-dialog.component';
import { CalibrationlogoEnum } from 'app/enum/calibrationlogoEnum';
import { TDocumentDefinitions } from 'pdfmake/interfaces';
import QRCode from 'qrcode';
import { _isPersonId } from 'app/services/auth.service';
import { PdfFontService } from 'app/services/common/pdf-font.service';
import pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';  // Import vfs_fonts
import { UpdateCalibration } from 'app/dtos/calibration/updateCalibration';
import { GetCustomerSettingDetailDTO } from 'app/dtos/customer-setting/getCustomerSettingDetailDTO';
import { CustomerSettingService } from 'app/services/models/customer-setting.service';
import { TurkakService } from 'app/services/api/turkak.service';


@Component({
  selector: 'app-certificate-revise-dialog',
  templateUrl: './certificate-revise-dialog.component.html',
  styleUrls: ['./certificate-revise-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CertificateReviseDialogComponent implements OnInit {
  @Input() data: { certificateId: number, certificateNo: string }
  certificate: any = null;
  calibration: any = null;
  private _unsubscribeAll: Subject<any>;
  certificateNumber: string = null;
  public coreConfig: any;
  pageCount: number = 2;
  totalPages: number = 0;
  certificateFirstNo: string = null;
  turkakQrBase64;
  certificationBodyDocumentNumber: string = null;
  measurementResultBase64: any = null;;
  isSaving = false;

  is_Loading: boolean = false;

  constructor(
    public activeModal: NgbActiveModal,
    private certificateService: CertificateService,
    private _coreConfigService: CoreConfigService,
    private toastrService: ToastrService,
    private calibrationService: CalibrationService,
    private certificateReservationService: CertificateReservationService,
    @Inject('backendUrl') private backendUrl: string,
    private pdfFontService: PdfFontService,
    private customerSettingService: CustomerSettingService,
    private turkakService: TurkakService
  ) {
    pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.10.377/pdf.worker.min.js';
    this._unsubscribeAll = new Subject();
  }

  async ngOnInit() {
    await this.getByIdCertificate(this.data.certificateId);
  }

  async getByIdCertificate(id) {
    this.is_Loading = true;
    const cert = await this.certificateService.getByIdCertificate(id);
    console.log(cert);
    this.certificate = cert;
    await this.getByIdCalibration(cert.calibrationId);
    const lastMeasurementFile = [...this.certificate.certificateRevises]
      .reverse();
    this.certificateNumber =
      lastMeasurementFile[0]?.isEyeReviseNo === false
        ? this.certificate.certificateNo
        : this.certificate.certificateNo + (lastMeasurementFile[0]?.no ?? '');
    this.is_Loading = false;
  }

  async getByIdCalibration(id) {
    const data = await this.calibrationService.getByIdReadyCalibration(id);
    console.log(data);
    this.calibration = data;
    const missingFields = [];
    if (!this.calibration.deviceSeriNo) missingFields.push("Seri Numarası");
    if (!this.calibration.deviceBrand) missingFields.push("Marka");
    if (!this.calibration.deviceModel) missingFields.push("Model");
    if (!this.calibration.deviceResolution) missingFields.push("Çözünürlük");
    if (!this.calibration.devicePlace) missingFields.push("Yer");
    if (!this.calibration.deviceInventoryNumber) missingFields.push("Envanter No");
    if (!this.calibration.deviceReferenceMax && !this.calibration.deviceReferenceMin) missingFields.push("Cihaz Referans Aralığı");

    if (missingFields.length > 0) {
      const message = `Kalibrasyon yapılan cihazın şu bilgileri eksik: ${missingFields.join(", ")}`;
      this.toastrService.warning(message, "Eksik Bilgi Uyarısı", {
        timeOut: 0, // Toastr otomatik kapanmasın
        extendedTimeOut: 0,
        toastClass: 'toast ngx-toastr',
        closeButton: true, // Kapatma butonu ekle
      });
    }

    let path = null;
    if (this.calibration.deviceSeriNo != null)
      path = this.calibration.deviceSeriNo + "-" + this.calibration.deviceCode + "-" + this.calibration.deliveryCode;
    else
      path = this.calibration.deviceCode + "-" + this.calibration.deliveryCode;


    const lastMeasurementFile = [...this.certificate.certificateRevises]
      .reverse()
      .find(p => p.is_MeasurementFile === true);

    // 🔥 varsa no'yu path'in sonuna ekle
    if (lastMeasurementFile?.no != null) {
      path = `${path}-${lastMeasurementFile.no}`;
    }

    console.log(path);
    await this.getCalibrationMeasurementResultBase64(path);

  }

  closeModal(result: boolean = false) {
    this.activeModal.close(result);
  }


  async saveData(isPrivate) {
    let turkakCalibrationId: string | null = null;

    if (this.calibration.turkakCalibrationId != null) {
      turkakCalibrationId = this.calibration.turkakCalibrationId;
      const maxRetries = 8;  // toplam deneme sayısı
      const delayMs = 3000;  // 5 saniye bekleme
      let turkakCertificate = await this.turkakService.getCertificate(turkakCalibrationId);

      for (let attempt = 1; attempt <= maxRetries; attempt++) {
        turkakCertificate = await this.turkakService.getCertificate(turkakCalibrationId);
        console.log(`TÜRKAK sertifika deneme ${attempt}:`, turkakCertificate);

        if (turkakCertificate?.CertificationBodyDocumentNumber) {
          console.log('CertificationBodyDocumentNumber bulundu ✅');
          break;
        }

        if (attempt < maxRetries) {
          console.log(`CertificationBodyDocumentNumber henüz gelmedi, ${delayMs / 1000} saniye bekleniyor...`);
          await new Promise(resolve => setTimeout(resolve, delayMs));
        }
      }

      if (!turkakCertificate?.CertificationBodyDocumentNumber) {
        this.toastrService.warning(
          "CertificationBodyDocumentNumber bilgisi henüz TÜRKAK sisteminden alınamadı.",
          "TÜRKAK Uyarısı"
        );
        return; // devam etmiyoruz çünkü bilgi eksik
      }


      console.log(turkakCertificate);
      if (turkakCertificate != null) {
        this.certificationBodyDocumentNumber = turkakCertificate.CertificationBodyDocumentNumber;
        const certID = turkakCertificate.ID;
        const tbdsNumber = turkakCertificate.TBDSNumber;
        const qrBlob = await this.turkakService.getCertificateQrPng(certID, tbdsNumber); // URL: /GetQR/{certID}/{tbdsNumber}
        this.turkakQrBase64 = await this.convertBlobToBase64(qrBlob);
      }
    }
    await this.pdfDetail(isPrivate);
  }

  convertBlobToBase64(blob: Blob): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onerror = () => reject(new Error('Base64 dönüşüm hatası'));
      reader.onload = () => resolve(reader.result as string);
      reader.readAsDataURL(blob);
    });
  }


  async getCalibrationMeasurementResultBase64(path: string) {
    try {
      var result = await this.calibrationService.getCalibrationMeasurementResultBase64(path);
      console.log('Backend\'den gelen ölçüm sonucu:', result);

      if (result && result.base64 != null && result.base64.length > 0) {
        console.log('Base64 veri alındı, uzunluk:', result.base64.length);
        this.measurementResultBase64 = await this.convertPdfPagesToImages(result.base64);
        console.log('Ölçüm görselleri hazırlandı, sayfa sayısı:', this.measurementResultBase64?.length || 0);
      } else {
        console.warn('Backend\'den base64 veri gelmedi veya boş');
        this.measurementResultBase64 = [];
      }
    } catch (error) {
      console.error('getCalibrationMeasurementResultBase64 hatası:', error);
      this.measurementResultBase64 = [];
    }
  }


  async convertPdfPagesToImages(pdfBase64: string): Promise<any[]> {
    if (!pdfBase64) return [];

    const pdfData = atob(pdfBase64);
    const pdfContainer = document.getElementById('pdf-container');

    if (!pdfContainer) {
      console.warn('PDF önizleme konteyneri (#pdf-container) bulunamadı.');
    } else {
      pdfContainer.innerHTML = '';
      const header = document.createElement('h3');
      header.textContent = 'Ölçüm Sonuçları PDF Önizlemesi';
      pdfContainer.appendChild(header);
    }

    const pdf = await pdfjsLib.getDocument({ data: pdfData }).promise;
    const numPages = pdf.numPages;
    const imagesArray: any[] = [];
    const scaleFactor = 4.0; // Yüksek kalite (çalışan kodla aynı)

    for (let i = 1; i <= numPages; i++) {
      const page = await pdf.getPage(i);
      const viewport = page.getViewport({ scale: scaleFactor });

      // TAM SAYFA RENDER
      const canvas = document.createElement('canvas');
      const context = canvas.getContext('2d')!;
      canvas.height = viewport.height;
      canvas.width = viewport.width;

      // Sayfayı hiçbir kesme işlemi olmadan tam olarak çiziyoruz
      await page.render({ canvasContext: context, viewport: viewport }).promise;

      // Önizleme konteynerine ekle (Kırpılmamış tam haliyle)
      if (pdfContainer) {
        canvas.style.maxWidth = '100%';
        canvas.style.height = 'auto';
        canvas.style.border = '1px solid #ccc';
        canvas.style.margin = '10px 0';

        const pageHeader = document.createElement('h4');
        pageHeader.textContent = `Sayfa ${i} (Tam Sayfa)`;
        pdfContainer.appendChild(pageHeader);
        pdfContainer.appendChild(canvas);
      }

      // Base64 formatına dönüştür (çalışan kodla aynı: JPEG)
      const base64Image = canvas.toDataURL('image/jpeg', 0.95);

      imagesArray.push({
        image: base64Image,
        width: 570, // A4 genişliği (çalışan kodla aynı)
        //pageBreak: 'after', // Her ölçüm görseli yeni bir sayfada başlasın
        //margin: [0, -60, 0, 0] // İstediğiniz üst boşluk ayarı
      });
    }

    return imagesArray;
  }

  async pdfDetail(isSave: boolean) {
    this._coreConfigService.config.pipe(takeUntil(this._unsubscribeAll)).subscribe(config => {
      this.coreConfig = config;
      console.log(this.coreConfig);
    });
    console.log(this.coreConfig);
    this.getByIdLogo(this.calibration.accreditationOrganization)
    const logoKey = Object.keys(CalibrationlogoEnum);
    const key = logoKey[this.calibration.accreditationOrganization - 1];
    Object.keys(this.coreConfig.akraditasyonCompanies).find(k => k === key);
    const value = this.coreConfig.akraditasyonCompanies[key];
    console.log(value);
    if (this.calibration.akraditationCompanyFile) {
      if (!this.calibration.akraditationCompanyFile.startsWith('data:image/png;base64,')) {
        this.calibration.akraditationCompanyFile = 'data:image/png;base64,' + this.calibration.akraditationCompanyFile;
      }
    }

    const issueDate: Date = new Date(this.calibration.calibrationDate);
    const year = issueDate.getFullYear().toString().slice(-2); // Yılın son iki basamağını al
    const month = (issueDate.getMonth() + 1).toString().padStart(2, '0'); // Ayı iki basamağa tamamla
    const formattedDate = month + '.' + year;

    let finalCertificateNo = this.certificateNumber;

    /*
    if (!this.certificateForm.value.isPrivateResiveNo) {
      // "-R" ile başlayan son eki kaldır
      finalCertificateNo = this.certificateNumber.replace(/-R\d+$/, '');
    }*/

    const headerBilgi: headerBilgileri = {
      akraditationNo: value ?? '',
      akraditationFirma: Number('1'), //this.selectedAcradtionOrganizationId
      acradtionOrganizationId: Number('1'), //this.selectedAcradtionOrganizationId
      certificateNo: finalCertificateNo,
      certificateTarih: formattedDate,
      firmaAdi: this.calibration.akraditationCompany,
      firmaAdresi: this.calibration.akraditationCompanyAddres ?? '',
      firmaLogo: this.calibration.akraditationCompanyFile ?? '',
    }

    const calibrationDate = new Date(this.calibration.calibrationDate);
    const formattedCalibrationDate = `${calibrationDate.getDate().toString().padStart(2, '0')}.${(calibrationDate.getMonth() + 1).toString().padStart(2, '0')}.${calibrationDate.getFullYear()}`;

    //const confirmedPerson = this.calCompanyPerson.find(p => p.id == this.certificateForm.value.personId);

    const calibrationData: CalibrationData = {
      deviceOwner: this.calibration.certficateCompany,
      address: this.calibration.companyAddress ?? '',
      orderNumber: this.calibration.transactionManagementNo,
      deviceName: this.calibration.deviceName,
      manufacturer: this.calibration.deviceBrand,
      modelType: this.calibration.deviceModel,
      serialNumber: this.calibration.deviceSeriNo + '\t' + (this.calibration.deviceInventoryNumber != null ? '/' : '') + '\t' + (this.calibration.deviceInventoryNumber ?? ''),
      calibrationDate: formattedCalibrationDate,
      certificateNo: this.certificateNumber,
      firstPageDescription: 1 ? this.calibration.firstPageDescriptions[2].description : this.calibration.firstPageDescriptions[0].description, //this.selectedAcradtionOrganizationId == 3
      kalYapan: this.calibration.person,
      onaylayan: '', //confirmedPerson.fullName ??
      certificatePageNumber: this.pageCount + 3, //this.totalPages
      firtsPageFooterDescription: this.calibration.firstPageDescriptions[1].description,
      place: this.calibration.devicePlace ?? ''
    };

    const referenceString = (this.calibration.deviceReferenceMin && this.calibration.deviceReferenceMax && this.calibration.deviceReferenceUnitType)
      ? `${this.calibration.deviceReferenceMin}-${this.calibration.deviceReferenceMax} ${this.calibration.deviceReferenceUnitType}`
      : '-';
    const deliveryDate = new Date(this.calibration.deliveryDate);

    const formattedDeliveryDate = `${deliveryDate.getDate().toString().padStart(2, '0')}.${(deliveryDate.getMonth() + 1).toString().padStart(2, '0')}.${deliveryDate.getFullYear()}`;

    const references: Reference[] = this.calibration.calibrationReferencesDevices.map(device => ({
      deviceName: device.deviceName,
      brand: device.brandName,  // 'brandName' -> 'brand'
      model: device.modelName,  // 'modelName' -> 'model'
      serialNumber: device.seriNo,  // 'seriNo' -> 'serialNumber'
      certificateNumber: device.referenceDeviceMovement.calibrationNo,  // 'calibrationNo' -> 'certificateNumber'
      calibrationDate: this.formatDate(device.referenceDeviceMovement.calibrationDate),  // Format edilmiş tarih
      tracebility: device.referenceDeviceMovement.traceability  // 'traceability' -> 'tracebility'
    }));

    const calibrationDataPage2: CalibrationPage2 = {
      device: {
        deviceName: this.calibration.deviceName,
        serialNo: this.calibration.deviceSeriNo,
        deviceNumber: this.calibration.deviceInventoryNumber ?? '-',
        location: this.calibration.devicePlace ?? '-',
        brand: this.calibration.deviceBrand,
        type: this.calibration.deviceModel,
        range: this.calibration.place ? 'Yerinde' : formattedDeliveryDate, // referenceString,
        resolution: this.calibration.deviceResolution ?? '-',
        incomingDateOfDeviceLaboratory: this.calibration.placeAddress, //this.calibration.isPlace ? 'Yerinde' : formattedDeliveryDate,
        visualFunctionInspectionDevice: this.calibration.visualAndFunctional ? 'Uygun' : 'Uygun Değil'
      },
      references: references,
      evironmentalConditions: this.calibration.enviromentalContents,
      calibrationMethod: this.calibration.calibrationMethodDescription,
      remarks: this.calibration.procedureDescription,
      compliance: this.calibration.conformityDeclartion,
      measurement: this.calibration.measurementUncertaintyDescription,
      measurementUncertainty: this.calibration.measurementUncertaintyDescription,
      description: this.calibration.calibrationMethodDescription,
      reviseDescription: this.certificate.certificateRevises[this.certificate.certificateRevises.length - 1]?.isEyeDescription
        ? this.calibration.certificateRevises[this.certificate.certificateRevises.length - 1].description
        : null
    };

    await this.generatePDF(headerBilgi, calibrationData, calibrationDataPage2, isSave);
  }

  logo = null;
  getByIdLogo(number: number): string | null {
    console.log(number);
    const logos = Object.values(CalibrationlogoEnum);
    console.log(logos);
    this.logo = logos[number - 1] || null;
    console.log(this.logo);
    return this.logo;
  }

  formatDate(date: string): string {
    const newDate = new Date(date);
    const day = String(newDate.getDate()).padStart(2, '0');
    const month = String(newDate.getMonth() + 1).padStart(2, '0'); // Aylar 0'dan başladığı için +1 yapıyoruz
    const year = newDate.getFullYear();
    return `${day}.${month}.${year}`;  // Gün.Ay.Yıl formatı
  }

  customerSetting: GetCustomerSettingDetailDTO;

  async generatePDF(headerData: headerBilgileri, calibrationData: CalibrationData, calibrationPage2: CalibrationPage2, isSave: boolean = false) {
    await this.pdfFontService.loadFonts();

    // Convert image paths to Base64 asynchronously
    calibrationData.certificatePageNumber = this.pageCount + this.totalPages;
    // headerData.firmaLogo = await this.convertImageToBase64(headerData.firmaLogo) || '';
    this.customerSetting = await this.customerSettingService.getCustomerSettingDetail(1);
    // console.log(this.pdfDoc);

    // Çalışan kodla aynı şekilde görselleri map ile oluştur
    console.log('measurementResultBase64:', this.measurementResultBase64);
    console.log('measurementResultBase64 uzunluğu:', this.measurementResultBase64?.length || 0);


    const pdfImages = (this.measurementResultBase64 || []).map(img => ({
      image: img.image,
      width: img.width,
      height: 645,
      pageBreak: img.pageBreak,
      margin: [-20, -110, 0, 0]
    }));

    calibrationData.certificatePageNumber += pdfImages.length;

    let akraditasyonFirma = '';
    if (headerData.akraditationFirma == 1) {
      if (this.customerSetting.turkakLogo != null)
        akraditasyonFirma = this.customerSetting.turkakLogo;
    } else if (headerData.akraditationFirma == 2) {
      if (this.customerSetting.nacLogo != null)
        akraditasyonFirma = this.customerSetting.nacLogo;
    }
    else if (headerData.akraditationFirma == 3) {
      if (this.customerSetting.traceabilityLogoPath != null)
        akraditasyonFirma = this.customerSetting.traceabilityLogoPath
    } else if (headerData.akraditationFirma == 4) {
      if (this.customerSetting.iasLogo != null)
        akraditasyonFirma = this.customerSetting.iasLogo
    }
    /* if (headerData.akraditationFirma == 1 || headerData.akraditationFirma == 2 || headerData.akraditationFirma == 3) {
      const akraditasyonLogoPath = this.getByIdLogo(headerData.akraditationFirma);
      akraditasyonFirma = await this.convertImageToBase64(akraditasyonLogoPath) || '';
    }*/

    /*
if (this.selectProcedureId != null) {
  this.selectProcedure = this.kindProcedures?.find(p => p.id == this.selectProcedureId);
  console.log(this.selectProcedure);
}*/

    // Content'i önce oluştur (debug için)
    const page1Content = await this.createCalibrationPageContent(calibrationData, true);
    const page2Content = this.createCalibrationPage2(calibrationPage2);

    console.log('Page1 content hazırlandı');
    console.log('Page2 content hazırlandı');
    console.log('pdfImages uzunluğu:', pdfImages.length);

    const content = [
      page1Content,
      page2Content,
      ...pdfImages
    ];

    console.log('Toplam content uzunluğu:', content.length);
    console.log('Content içindeki görsel sayısı:', content.filter(item => item && item.image).length);

    // Document definition
    const documentDefinition = {
      pageSize: 'A4',
      pageMargins: [35, 215, 35, 90],
      defaultStyle: {
        font: 'RobotoSerif', // Using the custom font
      },
      background: (currentPage, pageSize) => {
        if (!this.calibration.akraditationCompanyFile) return null;
        return {
          image: `${headerData.firmaLogo}`,
          width: 450,
          opacity: 0.1,
          absolutePosition: { x: 75, y: 350 }
        };
      },
      // Header for each page
      header: (currentPage, pageCount, pageSize) => {
        return this.getHeaderContent(currentPage, pageCount, akraditasyonFirma, headerData);
      },
      // Content of the document (multiple pages) - çalışan kodla aynı şekilde spread operatörü kullan
      content: content,
      // Footer for each page
      footer: (currentPage, pageCount) => this.getFooterContent(currentPage, pageCount, calibrationData.firtsPageFooterDescription)
    }

    console.log('PDF document definition oluşturuldu');
    const pdfDocGenerator = pdfMake.createPdf(documentDefinition as unknown as TDocumentDefinitions);
    console.log('PDF generator oluşturuldu');


    if (isSave) {
      pdfDocGenerator.getBase64(async (base64Data) => {
        try {
          const lastCertRevise = [...this.certificate.certificateRevises]
            .reverse();
          const certReservNo = lastCertRevise[0]?.no;
          const certNo = this.certificate.certificateNo + "-" + certReservNo

          const data = await this.certificateService.saveCertificateBase64(
            this.calibration.certificateId,
            base64Data,
            certNo,
            this.calibration.calibrationNo
          );

          if (data.status) {
            this.closeModal(true);
            this.toastrService.success(data.message);
          } else {
            this.toastrService.error(data.message);
          }
        } catch (innerError) {
          console.error('Certificate creation error:', innerError);
          this.toastrService.error('Sertifika oluşturulurken bir hata oluştu.');
        } finally {
          this.isSaving = false; // işlem tamamlandı
        }
      })
    } else {
      pdfDocGenerator.open();
    }
    // Generate and open the PDF
  }

  qrCodeBase64: string;

  async generateQRCode(certificateNo: string): Promise<void> {
    // URL'yi oluşturuyoruz
    const url = `${this.backendUrl}api/Certificates/verify/${this.calibration.calibrationNo}-${certificateNo}.pdf`;
    try {
      // QR kodunu Base64 formatında oluşturuyoruz
      const qrCanvas = document.createElement('canvas');
      await QRCode.toCanvas(qrCanvas, url, { width: 250 });

      // 2️⃣ Yeni bir canvas oluştur (QR + metin için)
      const finalCanvas = document.createElement('canvas');
      const ctx = finalCanvas.getContext('2d')!;
      const qrSize = qrCanvas.width;
      const textHeight = 40; // alt boşluk
      finalCanvas.width = qrSize;
      finalCanvas.height = qrSize + textHeight;

      // 3️⃣ QR kodu çiz
      ctx.drawImage(qrCanvas, 0, 0);

      // 4️⃣ Metni çiz
      ctx.font = 'bold 32px Arial';
      ctx.textAlign = 'center';
      ctx.fillStyle = 'black';
      ctx.fillText(certificateNo, qrSize / 2, qrSize + 30);

      // 5️⃣ Base64 çıktısı al
      this.qrCodeBase64 = finalCanvas.toDataURL('image/png');
    } catch (err) {
      console.error('QR Kod oluşturulurken hata oluştu:', err);
    }
  }

  async createCalibrationPageContent(calibrationData: CalibrationData, pageBreak: boolean) {
    let firstPageDescriptionToHtml = htmlToPdfmake(calibrationData.firstPageDescription);
    firstPageDescriptionToHtml = this.applyDefaultFontSize(firstPageDescriptionToHtml, 8, 7);

    //const seal = await this.convertImageToBase64('/assets/logo/muhur.png').catch(err => console.log(err));
    const imza1 = await this.convertImageToBase64('/assets/logo/e-imza.png').catch(err => console.log(err));
    let seal = this.customerSetting.stampImage;
    await this.generateQRCode(calibrationData.certificateNo);
    return [
      {
        table: {
          widths: ['30%', '70%'], // İlk sütun başlık, ikinci sütun veri
          body: [
            [{ text: 'Cihaz Sahibi / Adresi', bold: true, fontSize: 9 }, { text: `${calibrationData.deviceOwner}`, fontSize: 9 }],
            [{ text: 'Customer / Address', italics: true, fontSize: 7, margin: [0, 0, 0, 2] }, { text: `${calibrationData.address}`, fontSize: 7 }],

            [{ text: 'Sipariş Numarası', bold: true, fontSize: 9 }, { text: `${calibrationData.orderNumber ?? '-'}`, fontSize: 9 }],
            [{ text: 'Order No', italics: true, fontSize: 7, margin: [0, 0, 0, 2] }, {}],

            [{ text: 'Cihaz', bold: true, fontSize: 9 }, { text: `${calibrationData.deviceName}`, fontSize: 9 }],
            [{ text: 'Device', italics: true, fontSize: 7, margin: [0, 0, 0, 2] }, {}],

            [{ text: 'İmalatçı', bold: true, fontSize: 9 }, { text: `${calibrationData.manufacturer}`, fontSize: 9 }],
            [{ text: 'Brand', italics: true, fontSize: 7, margin: [0, 0, 0, 2] }, {}],

            [{ text: 'Model / Tip', bold: true, fontSize: 9 }, { text: `${calibrationData.modelType}`, fontSize: 9 }],
            [{ text: 'Type', italics: true, fontSize: 7, margin: [0, 0, 0, 2] }, {}],

            [{ text: 'Seri Numarası / Envanter No', bold: true, fontSize: 9 }, { text: `${calibrationData.serialNumber}`, fontSize: 9 }],
            [{ text: 'Serial Number / Inventory Number', italics: true, fontSize: 7, margin: [0, 0, 0, 2] }, {}],

            [{ text: 'Kalibrasyon Tarihi', bold: true, fontSize: 9 }, { text: `${calibrationData.calibrationDate}`, fontSize: 9 }],
            [{ text: 'Date of Calibration', italics: true, fontSize: 7, margin: [0, 0, 0, 2] }, {}],

            [{ text: 'Sertifika Sayfa Sayısı', bold: true, fontSize: 9 }, { text: `${calibrationData.certificatePageNumber}`, fontSize: 9 }],
            [{ text: 'Number of Pages of The Certificate', italics: true, fontSize: 7, margin: [0, 0, 0, 2] }, {}],

            //[{ text: 'Bulunduğu Yer', bold: true, fontSize: 9 }, { text: `${calibrationData.place}`, fontSize: 9 }],
            //[{ text: 'Location Of Equipment', italics: true, fontSize: 7, margin: [0, 0, 0, 2] }, {}],
          ]
        },
        layout: 'noBorders', // Tablo çizgilerini kaldırdım
        margin: [0, -12, 0, 1],
      },
      {
        stack: [firstPageDescriptionToHtml],
        margin: [0, 5, 0, 10]
      },

      {
        table: {
          widths: ['25%', '25%', '25%', '25%',],
          body: [
            [{ text: "Mühür", bold: true, fontSize: 8, alignment: 'center' }, { text: 'Yayımlanma Tarihi', bold: true, fontSize: 8, alignment: 'center' }, { text: "Kalibrasyon Yapan", bold: true, fontSize: 8, alignment: 'center' }, { text: "Onaylayan", bold: true, fontSize: 8, alignment: 'center' },],
            [{ text: "Seal", fontSize: 6, alignment: 'center', italics: true }, { text: 'Issue Date', fontSize: 8, alignment: 'center', italics: true }, { text: "Calibrated by", fontSize: 6, alignment: 'center', italics: true }, { text: "Approval", fontSize: 6, alignment: 'center', italics: true }],
            [
              { image: seal, fit: [85, 85], alignment: 'center' },
              { text: `${(new Date(this.certificate.issueDate)).toLocaleDateString('tr-TR')}`, fontSize: 10, alignment: 'center', marginTop: 15 },
              [
                { text: calibrationData.kalYapan, fontSize: 10, alignment: 'center', marginBottom: 5, marginTop: 15 },
                { text: 'E-imzalıdır!', fontSize: 10, bold: true, italics: true, alignment: 'center', color: '#FF0000' }
              ],
              [
                { text: calibrationData.onaylayan, fontSize: 10, alignment: 'center', marginBottom: 5, marginTop: 15 },
                { text: 'E-imzalıdır!', fontSize: 10, bold: true, italics: true, alignment: 'center', color: '#FF0000' },
                {
                  text: `${calibrationData.calibrationDate}`,
                  fontSize: 8,
                  alignment: 'center'
                }
              ],
            ]
          ],
        },
        layout: 'noBorders',
        margin: [0, 5, 0, 0],
      },
      pageBreak ? { text: '', pageBreak: 'after' } : { text: '' },
    ];
  }

  applyDefaultFontSize(obj: any, normalFontSize: number = 7, smallFontSize: number = 5) {
    if (Array.isArray(obj)) {
      return obj.map(item => this.applyDefaultFontSize(item, normalFontSize, smallFontSize));
    } else if (typeof obj === "object" && obj !== null) {
      // If the object contains text and doesn't have fontSize defined
      if (obj.text && !obj.fontSize) {
        // Apply the normal font size by default
        obj.fontSize = normalFontSize;
      }

      // Adjust the font size if 'ql-size-small' is present in style
      if (obj.text && obj.style?.includes("ql-size-small")) {
        obj.fontSize = smallFontSize; // Apply small font size
      }

      // If the object has margin, reduce it by 10%
      if (obj.margin) {
        obj.margin = obj.margin.map((m: number) => m * 0.1);
      }

      // Recursively apply the function to nested properties
      Object.keys(obj).forEach(key => {
        obj[key] = this.applyDefaultFontSize(obj[key], normalFontSize, smallFontSize);
      });
    }
    return obj;
  }

  createCalibrationPage2(calibrationPage2: CalibrationPage2) {
    let calibrationText = htmlToPdfmake(calibrationPage2.description);
    calibrationText = this.applyDefaultFontSize(calibrationText);

    let remaksToHtml = htmlToPdfmake(calibrationPage2.remarks);
    remaksToHtml = this.applyDefaultFontSize(remaksToHtml);

    let complianceToHtml = htmlToPdfmake(calibrationPage2.compliance);
    complianceToHtml = this.applyDefaultFontSize(complianceToHtml);

    let measurementToHtml = htmlToPdfmake(calibrationPage2.measurement);
    measurementToHtml = this.applyDefaultFontSize(measurementToHtml);
    return [
      {
        stack: [
          {
            text: [
              {
                text: "Kalibre Edilen Cihaz /", bold: true, fontSize: 10,
              },
              {
                text: "Device to be calibrate", fontSize: 8, italics: true
              },
            ],
            margin: [0, 0, 0, 0]
          },
          {
            columns: [
              {
                table: {
                  widths: ['50%', '50%'], // İki sütunlu tablo
                  body: [
                    // İlk tablo: Cihaz bilgileri
                    [{ text: 'Cihaz Adı / Device Name :', bold: true, fontSize: 8 }, { text: `${calibrationPage2.device.deviceName}`, fontSize: 8 }],
                    [{ text: 'Seri Numarası / Serial No :', bold: true, fontSize: 8 }, { text: `${calibrationPage2.device.serialNo}`, fontSize: 8 }],
                    [{ text: 'Cihaz No / Device No :', bold: true, fontSize: 8 }, { text: `${calibrationPage2.device.deviceNumber}`, fontSize: 8 }],
                    [{ text: 'Bulunduğu Yer / Location :', bold: true, fontSize: 8 }, { text: `${calibrationPage2.device.location}`, fontSize: 8 }],
                  ]
                },
                layout: 'noBorders', // Tablo çizgilerini kaldırdım
                margin: [0, 5, 0, 0],
              },
              {
                table: {
                  widths: ['50%', '50%'], // İkinci tablo: Model ve ölçüm bilgileri
                  body: [
                    [{ text: 'Marka / Brand', bold: true, fontSize: 8 }, { text: `${calibrationPage2.device.brand}`, fontSize: 8 }],
                    [{ text: 'Model / Model', bold: true, fontSize: 8 }, { text: `${calibrationPage2.device.type}`, fontSize: 8 }],
                    [{ text: 'Çözünürlük / Resolution', bold: true, fontSize: 8 }, { text: `${calibrationPage2.device.resolution}`, fontSize: 8 }],
                    [{ text: 'Lab. Kabul Tarihi \ Lab. Date', bold: true, fontSize: 8 }, { text: `${calibrationPage2.device.range}`, fontSize: 8 }],
                  ]
                },
                layout: 'noBorders', // Tablo çizgilerini kaldırdım
                margin: [0, 5, 0, 0],
              },
              // Tabloların altındaki ek bilgiler
            ],
          },
          {
            table: {
              widths: ['25%', '75%'],
              body: [
                [{ text: `Cihazın Kalibrasyon Yapıldığı Yer`, bold: true, fontSize: 8 }, { text: `${calibrationPage2.device.incomingDateOfDeviceLaboratory}`, fontSize: 8 }],
                [{ text: `Görsel ve Fonksiyonel Kontrol    `, bold: true, fontSize: 8 }, { text: `${calibrationPage2.device.visualFunctionInspectionDevice}`, fontSize: 8 }]
              ],
            },
            layout: 'noBorders',
            margin: [0, 0, 0, 0],
          },
          {
            stack: [
              {
                columns: [
                  {
                    text: [
                      { text: "Kalibrasyonda Kullanılan Cihazlar /", bold: true, fontSize: 10 },
                      { text: "References used in calibration", fontSize: 8, italics: true },
                    ]
                  }
                ],
                margin: [0, 10, 0, 0],
              },
              {
                table: {
                  widths: ['27%', '13%', '13%', '14%', '10%', '10%', '13%'], // 7 sütun için genişlikleri belirledim
                  body: [
                    [{ text: 'Cihaz Adı', fontSize: 8, bold: true }, { text: 'Marka', fontSize: 8, bold: true }, { text: 'Model', fontSize: 8, bold: true }, { text: 'Seri No', fontSize: 8, bold: true }, { text: 'Sertfika No', fontSize: 8, bold: true }, { text: 'Kal. Tarihi', fontSize: 8, bold: true }, { text: 'İzlenebilirlik', fontSize: 8, bold: true }],
                    [{ text: 'Device Name', fontSize: 7, italics: true, margin: [0, 0, 0, 5] }, { text: 'Brand', fontSize: 7, italics: true, margin: [0, 0, 0, 5] }, { text: 'Model', fontSize: 7, italics: true, margin: [0, 0, 0, 5] }, { text: 'Serial No', fontSize: 7, italics: true, margin: [0, 0, 0, 5] }, { text: 'Certificate No', fontSize: 7, italics: true, margin: [0, 0, 0, 5] }, { text: 'Cal. Date', fontSize: 7, italics: true, margin: [0, 0, 0, 5] }, { text: 'Tracebility', fontSize: 7, italics: true, margin: [0, 0, 0, 5] }],
                    ...calibrationPage2.references.map(ref => [
                      { text: ref.deviceName, fontSize: 8 },
                      { text: ref.brand, fontSize: 8 },
                      { text: ref.model, fontSize: 8 },
                      { text: ref.serialNumber, fontSize: 8 },
                      { text: ref.certificateNumber, fontSize: 8 },
                      { text: ref.calibrationDate, fontSize: 8 },
                      { text: ref.tracebility, fontSize: 8 } // İzlenebilirlik için örnek veri (isteğe bağlı)
                    ])
                  ],
                },
                layout: 'noBorders',
                margin: [0, 5, 0, 0],
              }

            ]
          },
          {
            stack: [
              {
                columns: [
                  {
                    text: [
                      { text: "Çevre Şartları /", bold: true, fontSize: 10 },
                      { text: "Environment Conditions", fontSize: 8, italics: true },
                    ]
                  }
                ],
                margin: [0, 10, 0, 0],
              },
              {
                table: {
                  widths: ["*", "*", "*"],
                  body: [
                    [{ text: "Tür / Kind", bold: true, fontSize: 8 }, { text: "Başlangıç / Start", bold: true, fontSize: 8 }, { text: "Bitiş / End", bold: true, fontSize: 8 }],
                    ...(calibrationPage2.evironmentalConditions || []).map(ref => [
                      { text: ref.name || "-", fontSize: 7 },
                      { text: ref.start || "-", fontSize: 7 },
                      { text: ref.end || "-", fontSize: 7 },
                    ])
                  ],
                },
                layout: 'noBorders',
                margin: [0, 5, 0, 0],
              }
            ]
          },
          {
            stack: [
              {
                columns: [
                  {
                    text: [
                      { text: "Kalibrasyon Metodu /", bold: true, fontSize: 10 },
                      { text: "Calibration Method", fontSize: 8, italics: true },
                    ]
                  },
                ],
                margin: [0, 10, 0, 0],
              },
              {
                stack: [calibrationText],
              }
            ]
          },
          {
            stack: [
              {
                columns: [
                  {
                    text: [
                      { text: "Açıklama /", bold: true, fontSize: 10 },
                      { text: "Remarks", fontSize: 8, italics: true },
                    ]
                  },
                ],
                margin: [0, 10, 0, 0],
              },
              {
                stack: [remaksToHtml]
              }
            ]
          },
          {
            stack: [
              {
                columns: [
                  {
                    text: [
                      { text: "Uygunluk Beyanı /", bold: true, fontSize: 10 },
                      { text: "Statement Of Complance", fontSize: 8, italics: true },
                    ]
                  },
                ],
                margin: [0, 10, 0, 0],
              },
              {
                stack: [complianceToHtml]
              }
            ]
          },
          {
            stack: [
              {
                columns: [
                  {
                    text: [
                      { text: "Ölçüm Belirsizliği /", bold: true, fontSize: 10 },
                      { text: "Measurement Uncertaintily", fontSize: 8, italics: true },
                    ]
                  },
                ],
                margin: [0, 10, 0, 0],
              },
              {
                stack: [measurementToHtml]
              }
            ]
          },
          calibrationPage2.reviseDescription ? {
            stack: [
              {
                columns: [
                  {
                    text: [
                      { text: "Revize Gerekçesi /", bold: true, fontSize: 10 },
                      {
                        text: "Justification Revision", fontSize: 8, italics: true
                      },
                    ]
                  },
                ],
                margin: [0, 10, 0, 0],
              },
              {
                text: calibrationPage2.reviseDescription, fontSize: 8
              }
            ]
          } : { text: '' },
        ],
        marginTop: -100
      },
      // Sayfa sonu eklemeleri (isteğe bağlı)
      { text: '', pageBreak: 'after' }, // Eğer sayfa sonu gerekiyorsa, sayfa kesme ekleyebilirsiniz
    ];
  }

  /*createCalibrationOtherPage(imgData: string[]) {
    const pageContent = [];
    // Sayfa başına bir görsel ekliyoruz ve her sayfada bir kırılma ekliyoruz.
    for (let i = 0; i < imgData.length; i++) {
      pageContent.push({
        image: imgData[i],
        alignment: 'center',
        fit: [580, 1400], // sayfaya sığacak şekilde
        margin: [0, 0, 0, 0], // Görsel ile header arasına boşluk bırakabiliriz
        absolutePosition: { x: this.pdfBuffer == true ? 20 : 60, y: this.pdfBuffer == true ? 110 : 100 }, // Y konumunu her sayfa için ayarlayabilirsiniz
        pageBreak: i < imgData.length - 1 ? 'after' : undefined // Son görselden sonra sayfa kırılması ekliyoruz
      });
    }
    return pageContent;
  }*/

  // Header content function
  getHeaderContent(currentPage, pageCount, akraditasyonFirma, headerData: headerBilgileri,) {
    return {
      stack: [
        {
          columns: [
            { ...this.getLeftColumn(headerData, currentPage, pageCount), width: '25%' },
            {
              ...this.getCenterColumn(headerData, currentPage), width: '52%' // sağdaki tabloya 2 birim boşluk bırak
            },
            headerData.acradtionOrganizationId != 3 ? {
              ...this.getOtherLogoColumn(headerData, currentPage),             // 3️⃣ diğer logo
              width: '*',
              margin: [0, 0, 2, 0], // sağdaki tabloya 2 birim boşluk bırak
            } :
              {
                text: '',
                width: '*',
                margin: [0, 0, 2, 0],
              },
            {
              ...this.getRightColumn(akraditasyonFirma, headerData.akraditationNo, headerData.certificateNo, headerData.certificateTarih, currentPage, headerData.firmaAdi?.split(' ')[0], this.calibration.akradetionOrganization),
              width: 'auto',
              alignment: 'right'

            }
          ],
          margin: [35, 12, 35, 5],
        },
        {
          text: `Sayfa (Page): ${currentPage} / ${pageCount}`,
          fontSize: 8,
          alignment: 'left',
          margin: [35, 2, 0, 0]   // soldan 35 px, üstten 5 px boşluk
        },
        {
          canvas: [{ type: 'line', x1: 35, y1: 0, x2: 565, y2: 0, lineWidth: 1 }],
        },
      ],
    };
  }

  // Left column content
  getLeftColumn(headerData, currentPage, totalPages) {
    const logoStack: any[] = [];

    // 🔹 1. sayfada firma logosu
    if (headerData.firmaLogo && currentPage === 1) {
      logoStack.push({
        image: headerData.firmaLogo,
        fit: [150, 150],
        margin: [0, -20, 0, 0],        // sola 0, üste -20, sağa 0, alta 0
        alignment: 'left'
      });

      // 🔹 QR Code logonun hemen altına
      if (this.qrCodeBase64) {
        logoStack.push({
          image: this.qrCodeBase64,
          //width:150,
          fit: [75, 75],
          margin: [20, 5, 0, 0],         // sola 0, üste 5, sağa 0, alta 0
          alignment: 'right'
        });
      }
    }

    return {
      stack: logoStack,
      alignment: 'left',
      minHeight: 100,
      margin: [0, 25, 0, 0]             // genel üst boşluk → 25
    };
  }


  // Center column content
  getCenterColumn(headerData, currentPage) {
    return {
      stack: [
        {
          noWrap: false,              // satır kırılabilsin
          text: `${headerData.firmaAdi}`,
          italics: true,
          bold: true,
          fontSize: 12,
          lineHeight: 1.1,
          margin: [15, headerData.firmaAdi.length && currentPage != 1 > 30 ? 10 : 20, 2, currentPage != 1 ? 10 : 0]
        },
        currentPage == 1 ? { text: `${headerData.firmaAdresi}`, italics: true, fontSize: 10, marginTop: 10, marginLeft: 10 } : { text: '' },

        currentPage == 1 ? { text: "KALİBRASYON SERTİFİKASI", bold: true, fontSize: 12, margin: [0, 25, 0, 0] } : { text: '' },
        currentPage == 1 ? { text: "Calibration Certificate", italics: true, fontSize: 8 } : { text: '' },
      ],

      alignment: 'center',
      marginTop: 20,
      marginLeft: 10
    };
  }

  getOtherLogoColumn(headerData, currentPage) {
    const otherLogoStack: any[] = [];
    if (this.customerSetting.otherLogo && currentPage === 1) {
      otherLogoStack.push({
        image: this.customerSetting.otherLogo,
        fit: [75, 90],
        alignment: 'rigth',
        margin: [0, 0, 0, 0]
      });
    } else {
      otherLogoStack.push({ text: '', width: 90, height: 90, opacity: 0 });
    }

    return {
      stack: otherLogoStack,
      alignment: 'rigth',
      minHeight: 100
    };
  }


  // Right column content
  getRightColumn(
    akraditasyonFirma: string,
    akraditationNo: string,
    certificateNo: string,
    certificateTarih: string,
    currentPage: number,
    companyName: string,
    akradetionNumber: number
  ) {
    const rightStack: any[] = [];
    akraditationNo = this.customerSetting.accreditationNo;
    this.certificateFirstNo = this.customerSetting.certificatePrefix;

    // ✅ 1. Üstte logo
    if (currentPage === 1 && akraditasyonFirma) {
      rightStack.push({
        image: akraditasyonFirma,
        witdh: 85,
        height: 85,
        fit: [75, 90],
        alignment: 'center',
        margin: [0, 5, 0, 0]
      });
    } else {
      // Sayfa 1 değilse boş alan koru
      rightStack.push({ text: '', width: 100, height: 100, opacity: 0 });
    }

    // ✅ 2. Turkak QR özel durumu
    if (this.coreConfig.isCalibratedTurkak === true && akradetionNumber === 1 && currentPage === 1) {
      rightStack.push({
        image: this.turkakQrBase64,
        fit: [65, 65],
        alignment: 'center',
        margin: [0, 5, 0, 0]
      });
      // Akreditasyon numarasındaki tüm '-' karakterlerini kaldır
      const revizeText = akraditationNo.slice(3).replace(/-/g, '') + '-' + certificateTarih + '-' + certificateNo;
      //this.certificationBodyDocumentNumber = revizeText;
      rightStack.push({
        //text: revizeText,
        text: this.certificationBodyDocumentNumber,
        fontSize: 7,
      });
    } else {
      // ✅ 3. Diğer durumlar – tabloyu koru
      rightStack.push({
        table: {
          widths: [55],
          body: [
            ...(akradetionNumber !== 3
              ? [[{ text: akraditationNo, alignment: 'center', fontSize: 7, bold: true, margin: [0, 2] }]]
              : [[{ text: companyName?.toUpperCase(), alignment: 'center', fontSize: 7, bold: true, margin: [0, 2] }]]),
            [{ text: `${this.certificateFirstNo}${certificateNo}`, alignment: 'center', fontSize: 7, bold: true, margin: [0, 2] }],
            [{ text: certificateTarih, alignment: 'center', fontSize: 7, bold: true, margin: [0, 2] }]
          ]
        },
        marginTop: 10,
        marginLeft: 0
      });
    }

    return {
      stack: rightStack,
      alignment: 'right',
      minHeight: 100
    };
  }


  // Footer content function
  getFooterContent(currentPage, pageCount, firstPageFooterDescription) {
    if (currentPage > 2) {
      return {};
    }
    console.log(firstPageFooterDescription);
    let firstPageFooterDescriptionToHtml = htmlToPdfmake(firstPageFooterDescription);
    firstPageFooterDescriptionToHtml = this.applyDefaultFontSize(firstPageFooterDescriptionToHtml, 8, 8);
    // İlk sayfa için footer içeriğini ayarlarken margin ve padding ekliyoruz.
    return {
      stack: [
        // Footer'da bir çizgi ekliyoruz
        {
          canvas: [{ type: 'line', x1: 35, y1: 0, x2: 565, y2: 0, lineWidth: 1 }],
        },
        {
          stack: [
            firstPageFooterDescriptionToHtml,
            ...(this.calibration.formNo ? [{ text: this.calibration.formNo.formNo, fontSize: 8 }] : [])
          ],
          margin: [35, 10, 35, 60], // Alt margin'ini biraz daha azaltarak daha fazla alan bırakıyoruz

          fontSize: 8, // Font boyutunu küçültüyoruz
        }

      ],
      margin: [0, -10, 0, 0]
    };
  }

  async convertImageToBase64(url: string): Promise<string | null> {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = 'anonymous'; // CORS hatalarını önlemek için
      img.src = url;

      img.onload = () => {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        if (!ctx) return reject(null);
        canvas.width = img.width;
        canvas.height = img.height;
        ctx.drawImage(img, 0, 0);
        resolve(canvas.toDataURL('image/png'));
      };

      img.onerror = (err) => {
        console.error("Resim yüklenemedi!", url, err);
        reject(null);
      };
    });
  }
}